/**
 * Generated by orval 🍺
 * Do not edit manually.
 * IST.Connect | v1
 * REST API backing the IST Connect web frontend. Provides endpoints to manage plugin configurations and inspect task execution results, logs, and dashboard data.
 * OpenAPI spec version: 1.0.0
 */
import type { DashboardPluginList } from "../model";

import { customFetch } from "../../customFetcher";

export const getGetDashboardUrl = () => {
	return `/istconnect-service-api/dashboard`;
};

/**
 * @summary Get complete dashboard information.
 */
export const getDashboard = async (options?: Parameters<typeof customFetch>[1]): Promise<DashboardPluginList> => {
	return customFetch<DashboardPluginList>(getGetDashboardUrl(), {
		...options,
		method: "GET",
	});
};
